export * from '@fhs/routing/src/routes/cart/(checkout)/index';
export { default } from '@fhs/routing/src/routes/cart/(checkout)/index';
